import {
  Banknote,
  BarChart3,
  CalendarClock,
  ClipboardCheck,
  Handshake,
  HardHat,
  TrendingUp,
  Truck,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/**
 * Enlace a una aplicación interna del Grupo Adelante.
 *
 * Las URLs son placeholder; reemplazar por la de cada Static Web App.
 */
export interface AppLink {
  id: string;
  nombre: string;
  descripcion: string;
  url: string;
  icono: LucideIcon;
}

export const apps: AppLink[] = [
  {
    id: 'bi-obras',
    nombre: 'Reportería de Obras',
    descripcion: 'Reportes de avance y estado de obras',
    url: 'https://biobras.adelante.cr',
    icono: BarChart3,
  },
  {
    id: 'utilidades',
    nombre: 'Utilidades e Ingresos',
    descripcion: 'Utilidades de obras e ingresos por venta',
    url: 'https://utilidades.adelante.cr',
    icono: TrendingUp,
  },
  {
    id: 'aprobaciones',
    nombre: 'Aprobaciones de Compra',
    descripcion: 'Aprobación de órdenes de compra en BC',
    url: 'https://aprobaciones.ord.adelante.cr',
    icono: ClipboardCheck,
  },
  {
    id: 'concreto',
    nombre: 'Control de Concreto',
    descripcion: 'Control de concreto en planta y obra',
    url: 'https://concreto.adelante.cr',
    icono: Truck,
  },
  {
    id: 'desembolsos',
    nombre: 'Desembolsos / Cartera',
    descripcion: 'Pagos de ventas y formalizaciones de banco',
    url: 'https://desembolsos.adelante.cr',
    icono: Banknote,
  },
  {
    id: 'socios',
    nombre: 'Pagos HB',
    descripcion: 'Pagos de exclusividad a socios QFI',
    url: 'https://qfi.adelante.cr',
    icono: Handshake,
  },
  {
    id: 'obras',
    nombre: 'Control de Obra',
    descripcion: 'Avances de obra en campo',
    url: 'https://obras.adelante.cr', // migración en curso
    icono: HardHat,
  },
  {
    id: 'pago-semanal',
    nombre: 'Pago Semanal',
    descripcion: 'Pagos semanales de planilla',
    url: 'https://pagosemanal.adelante.cr',
    icono: CalendarClock,
  },
];
